import script from "./GenericPagination.vue?vue&type=script&setup=true&lang=js"
export * from "./GenericPagination.vue?vue&type=script&setup=true&lang=js"

import "./GenericPagination.vue?vue&type=style&index=0&id=1ff37920&lang=scss"

const __exports__ = script;

export default __exports__